import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface PaginationProps {
  totalItems: number;
  itemsPerPage?: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({
  totalItems,
  itemsPerPage = 10,
  currentPage,
  onPageChange,
}: PaginationProps) => {
  const { t } = useTranslation();
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  const groupSize = 10;
  const currentGroup = Math.floor((currentPage - 1) / groupSize);
  const startPage = currentGroup * groupSize + 1;
  const endPage = Math.min(startPage + groupSize - 1, totalPages);

  const pages: number[] = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  const goToPage = (page: number) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  return (
    <PaginationWrap>
      {/* 이전 페이지 */}
      <Button
        disabled={currentPage === 1}
        onClick={() => goToPage(currentPage - 1)}
      >
        {t('common.previous')}
      </Button>

      {pages.map((page) => (
        <PageButton
          key={page}
          $active={page === currentPage}
          onClick={() => goToPage(page)}
        >
          {page}
        </PageButton>
      ))}

      {/* 다음 페이지 */}
      <Button
        disabled={currentPage === totalPages}
        onClick={() => goToPage(currentPage + 1)}
      >
        {t('common.next')}
      </Button>
    </PaginationWrap>
  );
};

export default Pagination;

const PaginationWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
`;

const Button = styled.button`
  min-width: 32px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  color: #374151;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

const PageButton = styled(Button)<{ $active?: boolean }>`
  background: ${({ $active }) => ($active ? '#2563eb' : '#fff')};
  color: ${({ $active }) => ($active ? '#fff' : '#374151')};
  border-color: ${({ $active }) => ($active ? '#2563eb' : '#d1d5db')};
`;
